import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/lib/api";

// Public share redirect: /f/{shareId} → backend streaming URL. No React work needed
// once the browser hits the backend; the response has Content-Disposition so the
// file downloads/opens inline. Renders a tiny placeholder while the redirect fires.
export default function ShareRedirect() {
  const { shareId } = useParams();
  useEffect(() => {
    if (shareId) window.location.replace(`${API}/files/share/${shareId}`);
  }, [shareId]);
  return (
    <div className="min-h-[60vh] grid place-items-center text-center px-6" data-testid="share-redirect">
      <div>
        <div className="w-10 h-10 mx-auto rounded-full border-4 border-[#E05E36] border-t-transparent animate-spin" />
        <div className="mt-4 text-sm text-stone-500">Opening shared file…</div>
      </div>
    </div>
  );
}
